<template>
  <div class="table-tab__container" tabindex="1" style="overflow-x: auto">
    <table class="table-tab__block table " style="width: 1600px">
      <thead class="table-tab__thead">
      <tr>
        <th rowspan="2">№ предложения</th>
        <th rowspan="2">Название контрагента</th>
<!--        <th rowspan="2">Статус протокола</th>-->
        <th colspan="2" class="border-left text-center"
            v-for="variant of enums.Votes.options.all">
          {{$t(variant.name)}}
        </th>
      </tr>
      <tr>
        <template v-for="variant of enums.Votes.options.all">
          <th class="border-left">Кол-во</th>
          <th>ФИО</th>
        </template>
      </tr>
      </thead>
      <tbody class="table-tab__tbody">
        <tr v-for="record of table" class="border-bottom">
          <td>
            <router-link class="table-tab__color u-text-underline"
                         :to="{
                             name: 'purchases-public-lot-alien-bid',
                             params: {
                               lotId: record.bid.lotId,
                               requestId: record.bid.requestId,
                               bidId: record.bid.bidId,
                               tab: 'bid'
                             }
                           }">
              {{record.bid.name}}
            </router-link>
          </td>
          <td>{{record.organization}}</td>
<!--          <td>-->
<!--            <span v-if="record.status">{{$t(record.status.label)}}</span>-->
<!--          </td>-->
          <template v-for="variant of enums.Votes.options.all">
            <td class="border-left">{{record.votes[variant.id].length}}</td>
            <td>
              <div v-for="item of record.votes[variant.id]">
                <v-popover class="d-inline-block" placement="bottom">
                  <label class="u-red-color u-text-underline">{{item.owner | fullName}}</label>

                  <template slot="popover">
                    <div>{{record.organization}}</div>
                    <div>предложение {{record.bid.name}}</div>
                    <div>{{item.reason}}</div>
                  </template>
                </v-popover>
              </div>
            </td>
          </template>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>По протоколу:</td>
          <td></td>
          <template v-for="variant of enums.Votes.options.all">
            <td class="border-left">{{total.votes[variant.id].length}}</td>
            <td>
              <div v-for="item of total.votes[variant.id]">
                <v-popover class="d-inline-block" placement="bottom" v-if="item.reason">
                  <label class="u-red-color u-text-underline">{{item.owner | fullName}}</label>

                  <template slot="popover">
                    <div>{{item.reason}}</div>
                  </template>
                </v-popover>
                <span v-else>
                  {{item.owner | fullName}}
                </span>
              </div>
            </td>
          </template>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      draft: {
        type: Object,
        required: true
      }
    },

    computed: {
      total() {
        const votes = this.lot.commission.map(m => {
          const v = _.find(this.draft.votes, {
            request: 0,
            bidNum: 0,
            owner: m.id
          });

          return {
            owner: m,
            vote: _.get(v, 'vote', new this.enums.Votes(this.enums.Votes.EMPTY)),
            reason: _.get(v, 'reason')
          }
        });

        return {
          votes: this.enums.Votes.options.all.reduce((acc, v) => {
            acc[v.id] = _.filter(votes, e => e.vote.valueOf() === v.id);
            return acc;
          }, {})
        }
      },

      table() {
        const result = [];

        for (const request of this.lot.requests) {
          if (request.state.DRAFT) continue;
          if (!this.draft.type.RECEIVING_REQUESTS && !this.draft.type.PROCESSING_REQUESTS && request.state.DECLINED) continue;

          for (const bid of request.bids) {
            if (!this.draft.type.RECEIVING_REQUESTS && !this.draft.type.PROCESSING_REQUESTS && bid.state.DECLINED) continue;

            const votes = this.lot.commission.map(m => {
              const v = _.find(this.draft.votes, {
                request: request.num,
                bidNum: bid.num,
                owner: m.id
              });

              return {
                owner: m,
                vote: _.get(v, 'vote', new this.enums.Votes(this.enums.Votes.EMPTY)),
                reason: _.get(v, 'reason')
              }
            });

            const status = _.get(_.find(this.draft.results, {
              request: request.num,
              bidNum: bid.num
            }), 'result');

            // let status = new this.enums.Votes(this.enums.Votes.NO);
            //
            // if (_.filter(this.draft.votes, v => v.vote.valueOf() === this.enums.Votes.YES).length > this.draft.votes.length / 2) {
            //   status = new this.enums.Votes(this.enums.Votes.YES);
            // }

            result.push(Vue.observable({
              bid: {
                lotId: this.lot.id,
                requestId: request.num,
                bidId: bid.id,
                bidNum: bid.num,
                name: `${this.lot.catalog.name} - ${request.num} - ${bid.num}`
              },

              organization: request.organization,
              status,
              votes: this.enums.Votes.options.all.reduce((acc, v) => {
                acc[v.id] = _.filter(votes, e => e.vote.valueOf() === v.id);
                return acc;
              }, {})
            }));
          }
        }

        return result;
      }
    },

    methods: {
      saveVote(draft, record) {
        return this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('voteForDraft', {
              lotId: this.lot.id,
              requestId: record.bid.requestId,
              bidId: record.bid.bidNum,
              protocolType: draft.type,
              version: draft.version,
              vote: record.vote,
              reason: record.reason
            });
          }
          catch(e) {
            console.error('failed voting for draft protocol', e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
